module.exports = __webpack_public_path__ + "img/9788968666612.4cafa65a.jpg";